<style scoped lang="scss">
.uk-card-primary {
  color: white;
  background-color: #6dadf1;
  padding: 10px;
  font-size: 1.2em;
  border-radius: 6px;
}
</style>

<template>
  <vk-modal :show.sync="isOpen" v-if="form">
    <div class="uk-grid">
      <div class="uk-width-1-1 uk-margin-top">
        <h2>{{ __("tenant.add_new_landlord") }}</h2>
        <span v-if="applicationRoleId === 3"
          ><small>{{ __("tenant.this_is_who_you_pay") }}</small></span
        >
        <br />
      </div>
      <div
        class="uk-width-1-1 uk-margin-top"
        v-if="programSettings['tenant-can-create-organizations']"
      >
        <label for="name">{{
          __("tenant.what_information_do_you_have", { roleName: roleName })
        }}</label>
        <select
          v-model="whatInformationDoYouHave"
          @change="onChangeType"
          class="uk-select uk-form-large"
        >
          <option :value="null">{{ __("tenant.make_a_selection") }}</option>
          <option :value="1">{{ __("tenant.i_know_company") }}</option>
          <option :value="2">{{ __("tenant.i_know_person") }}</option>
          <option :value="3">{{ __("tenant.i_know_both") }}</option>
        </select>
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-if="whatInformationDoYouHave">
        <button
          class="uk-button uk-button-primary"
          type="button"
          @click="copyAll"
        >
          Copy All From Landlord Form
        </button>
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-if="whatInformationDoYouHave">
        <validated-section :errors="errors" field="property_name">
          <label for="name"
            >{{ __("tenant.property_name")
            }}<span class="uk-text-danger uk-text-bold">*</span> :</label
          >
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('property_name', 'property_name')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Property Name"
            v-model="form.property_name"
            placeholder="Enter Property Name"
          ></text-input>
        </validated-section>
      </div>

      <div
        class="uk-width-1-1 uk-margin-top"
        v-if="whatInformationDoYouHave == 1 || whatInformationDoYouHave == 3"
      >
        <validated-section
          :errors="errors"
          field="organization.organization_name"
        >
          <label for="name"
            >{{ __("tenant.company_name")
            }}<span class="uk-text-danger uk-text-bold">*</span> :</label
          >
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('company_name', 'company_name')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Company Name"
            v-model="form.company_name"
            placeholder="Enter Company Name"
          ></text-input>
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave == 2 || whatInformationDoYouHave == 3"
      >
        <validated-section :errors="errors" field="person.first_name">
          <label for="name"
            >{{ __("tenant.landlord_first_name")
            }}<span class="uk-text-danger uk-text-bold">*</span> :</label
          >
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('first_name', 'first_name')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="First Name"
            v-model="form.first_name"
            placeholder="Enter First Name"
          ></text-input>
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave == 2 || whatInformationDoYouHave == 3"
      >
        <validated-section :errors="errors" field="person.last_name">
          <label for="name"
            >{{ __("tenant.landlord_last_name")
            }}<span class="uk-text-danger uk-text-bold">*</span> :</label
          >
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('last_name', 'last_name')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Last Name"
            v-model="form.last_name"
            placeholder="Enter Last Name"
          ></text-input>
        </validated-section>
      </div>

      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section :errors="errors" field="person.email">
          <label for="name"
            >{{ __("tenant.landlord_email")
            }}<span class="uk-text-danger uk-text-bold">*</span> :</label
          >
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('email', 'email')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Email Address"
            v-model="form.email"
            placeholder="Enter Email Address"
            type="email"
          ></text-input>
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section :errors="errors" field="person.phone">
          <label for="name">{{ __("tenant.landlord_phone_number") }}</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('phone', 'phone')"
            >
              Copy from LL Form
            </button>
          </span>
          <phone-number-input
            name="Phone"
            v-model="form.phone"
            @onInputChange="onPhoneChanged"
            placeholder=""
          >
          </phone-number-input>
        </validated-section>
      </div>

      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section
          :errors="errors"
          field="organization.address.address_1"
        >
          <label for="name">{{ roleName }} {{ __("global.address_1") }}:</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('address_1', 'address_1')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Address1"
            v-model="form.address_1"
            placeholder="Enter Address Line 1"
          />
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section
          :errors="errors"
          field="organization.address.address_2"
        >
          <label for="name">{{ roleName }} {{ __("global.address_2") }}:</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('address_2', 'address_2')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="Address2"
            v-model="form.address_2"
            placeholder="Enter Address Line 2"
          />
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section :errors="errors" field="organization.address.city">
          <label for="name">{{ roleName }} {{ __("global.city") }}:</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('city', 'city')"
            >
              Copy from LL Form
            </button>
          </span>
          <text-input
            name="City"
            v-model="form.city"
            placeholder="Enter City"
          />
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section
          :errors="errors"
          field="organization.address.state_id"
        >
          <label for="role">{{ roleName }} {{ __("global.state") }} :</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('state_id', 'state_id')"
            >
              Copy from LL Form
            </button>
          </span>
          <br />
          <select v-model="form.state_id" class="uk-width-1-1 uk-form-large">
            <option
              v-for="state in states"
              :value="state.id"
              :selected="form.state_id === state.id"
            >
              {{ state.name }}
            </option>
          </select>
        </validated-section>
      </div>
      <div
        class="uk-width-1-2 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <validated-section :errors="errors" field="organization.address.zip">
          <label for="name">{{ roleName }} {{ __("global.zip") }} :</label>
          <span
            class="uk-align-right"
            v-if="!programSettings['tenant-can-create-organizations']"
          >
            <button
              class="uk-button-small uk-button-default"
              @click="copyField('zip', 'zip')"
            >
              Copy from LL Form
            </button>
          </span>
          <br />
          <text-input
            name="Zip"
            v-model="form.zip"
            id="zip"
            placeholder="Enter ZIP"
          />
        </validated-section>
      </div>

      <div
        class="uk-width-1-1 uk-margin-top"
        v-if="whatInformationDoYouHave !== null"
      >
        <div class="uk-card uk-card-primary" v-if="permissions.pm">
          This will make a NEW property on EACH SAVE. Please only use this form
          if you are creating a new property that does not exist.
        </div>
      </div>
    </div>

    <div slot="footer" class="uk-text-right">
      <vk-button class="uk-margin-small-right" @click="isOpen = false">{{
        cancelText
      }}</vk-button>
      <vk-button type="primary" @click="save">{{ confirmText }}</vk-button>
    </div>
  </vk-modal>
</template>

<script>
import { mapState } from "vuex";
import ValidatedSection from "../../Common/ValidatedSection";
export default {
  name: "CreatePropertyContactModal",
  components: { ValidatedSection },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: "CANCEL",
    },
    confirmText: {
      type: String,
      default: "SAVE",
    },
    applicationRoleId: {
      type: Number,
      required: true,
    },
    table: {
      type: String,
      required: true,
    },
    prefix: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      whatInformationDoYouHave: null,
      hasInfoAboutCompany: false,
      hasInfoAboutPerson: true,
      errors: {},
      form: {
        phone: "",
      },
      states: [
        { id: "", name: "Select State" },
        { id: 1, name: "Alabama" },
        { id: 2, name: "Alaska" },
        { id: 3, name: "Arizona" },
        { id: 4, name: "Arkansas" },
        { id: 5, name: "California" },
        { id: 6, name: "Colorado" },
        { id: 7, name: "Connecticut" },
        { id: 8, name: "Delaware" },
        { id: 9, name: "District of Columbia" },
        { id: 10, name: "Florida" },
        { id: 11, name: "Georgia" },
        { id: 12, name: "Hawaii" },
        { id: 13, name: "Idaho" },
        { id: 14, name: "Illinois" },
        { id: 15, name: "Indiana" },
        { id: 16, name: "Iowa" },
        { id: 17, name: "Kansas" },
        { id: 18, name: "Kentucky" },
        { id: 19, name: "Louisiana" },
        { id: 20, name: "Maine" },
        { id: 21, name: "Maryland" },
        { id: 22, name: "Massachusetts" },
        { id: 23, name: "Michigan" },
        { id: 24, name: "Minnesota" },
        { id: 25, name: "Mississippi" },
        { id: 26, name: "Missouri" },
        { id: 27, name: "Montana" },
        { id: 28, name: "Nebraska" },
        { id: 29, name: "Nevada" },
        { id: 30, name: "New Hampshire" },
        { id: 31, name: "New Jersey" },
        { id: 32, name: "New Mexico" },
        { id: 33, name: "New York" },
        { id: 34, name: "North Carolina" },
        { id: 35, name: "North Dakota" },
        { id: 36, name: "Ohio" },
        { id: 37, name: "Oklahoma" },
        { id: 38, name: "Oregon" },
        { id: 39, name: "Pennsylvania" },
        { id: 40, name: "Rhode Island" },
        { id: 41, name: "South Carolina" },
        { id: 42, name: "South Dakota" },
        { id: 43, name: "Tennessee" },
        { id: 44, name: "Texas" },
        { id: 45, name: "Utah" },
        { id: 46, name: "Vermont" },
        { id: 47, name: "Virginia" },
        { id: 48, name: "Washington" },
        { id: 49, name: "West Virginia" },
        { id: 50, name: "Wisconsin" },
        { id: 51, name: "Wyoming" },
        { id: 52, name: "England (Country)" },
        { id: 53, name: "Manitoba (Canada)" },
      ],
    };
  },
  computed: {
    roleName() {
      return this.__("tenant.landlord_title");
      if (this.applicationRoleId == 3) {
        return "Landlord/Property Manager";
      }
      if (this.applicationRoleId == 4) {
        return "Property Owner";
      }
      return "";
    },
    ...mapState("App", {
      permissions: (state) => state.permissions,
    }),
    ...mapState("Application", {
      assets: (state) => state.assets,
      applicationId: (state) => state.application.id,
      application: (state) => state.application,
      householdApplicationLandlord: (state) =>
        state.householdApplicationLandlord,
      programSettings: (state) => state.application.program.settings,
    }),
    ...mapState("Landlord", {
      confirmation: (state) => state.confirmation,
    }),
  },
  watch: {
    programSettings(newValue) {
      if (!newValue["tenant-can-create-organizations"]) {
        this.whatInformationDoYouHave = 3;
      }
    },
  },
  mounted() {
    if (!this.programSettings["tenant-can-create-organizations"]) {
      this.whatInformationDoYouHave = 3;
    }
  },
  methods: {
    onChangeType() {
      this.form.company_name = "";
      this.form.first_name = "";
      this.form.last_name = "";
    },

    openEdit(contact) {
      this.form = contact;
      this.isOpen = true;
    },
    open() {
      let fields = {
        property_name: "",
        company_name: "",
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        address_1: "",
        address_2: "",
        city: "",
        state_id: null,
        state: "",
        zip: "",
      };
      let form = {};
      for (let field in fields) {
        form[field] = fields[field];
      }
      this.form = form;
      this.isOpen = true;
    },

    onConfirm() {},

    onPhoneChanged($event) {
      if ($event.isValid) {
        this.form.phone.area_code = $event.number.input.substr(0, 3);
        this.form.phone.phone_number = $event.number.input.substr(3, 7);
      }
    },

    copyAll() {
      this.copyField("property_name", "property_name");
      this.copyField("company_name", "company_name");
      this.copyField("first_name", "first_name");
      this.copyField("last_name", "last_name");
      this.copyField("email", "email");
      this.copyField("phone", "phone");
      this.copyField("address_1", "address_1");
      this.copyField("address_2", "address_2");
      this.copyField("city", "city");
      this.copyField("state_id", "state_id");
      this.copyField("state", "state");
      this.copyField("zip", "zip");
    },
    copyField(fromField, toField) {
      this.form[toField] = this.householdApplicationLandlord[fromField];
    },

    async save() {
      this.errors = {};
      this.$emit("beforeSubmit");
      setTimeout(async () => {
        let data = {
          type: this.whatInformationDoYouHave,
          organization: {
            organization_name: this.form.company_name,
            phone: this.form.phone,
            address: {
              line_1: this.form.address_1,
              line_2: this.form.address_2,
              city: this.form.city,
              state_id: this.form.state_id,
              zip: this.form.zip,
            },
          },
          person: {
            first_name: this.form.first_name,
            last_name: this.form.last_name,
            email: this.form.email,
            phone: this.form.phone,
          },
          role_id: this.applicationRoleId,
          property_name: this.form.property_name,
        };

        if (this.table == "household_applications") {
          let url = `/api/hope/applications/${this.applicationId}/contacts`;
          try {
            let r = await axios.post(url, data);
          } catch (e) {
            this.errors = e.response.data.errors;
            return;
          }
        } else {
          let url = `/api/landlord/${this.confirmation.id}/contacts`;
          try {
            let r = await axios.post(url, data);
          } catch (e) {
            this.errors = e.response.data.errors;
            return;
          }
        }

        this.$emit("done");
        this.isOpen = false;
      }, 1500);
    },
  },
};
</script>
